import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ITemporalPageData {
  enabled: boolean;
  component?: any;
}

@Injectable({
  providedIn: 'root',
})
export class TemporalPageService {
  temporalPageData$ = new BehaviorSubject<ITemporalPageData>({ enabled: false });

  constructor() {
  }

  openDistributorPage() {
    Promise.all([
      import('../../modules/distributors/distributors.module'),
      import('../../modules/distributors/distributor/distributor-info/distributor-info.component'),
    ]).then(([_, cmp]) => {
      this.temporalPageData$.next({
        enabled: true,
        component: cmp.DistributorInfoComponent,
      })
    });
  }
}
